module.exports = __webpack_public_path__ + "img/mortgages.6f97626.png";